import { StargraveLootResolution, StargraveLootRewardKind } from '../types';

export interface StargraveResolvedLoot {
  kind: StargraveLootRewardKind;
  amount?: number;
  technologyTable?: 1 | 2;
}

const validateRoll = (roll: number, label: string) => {
  if (!Number.isInteger(roll) || roll < 1 || roll > 20) throw new Error(`${label} must be between 1 and 20.`);
};

export function resolveStargraveLoot(resolution: StargraveLootResolution): StargraveResolvedLoot {
  validateRoll(resolution.roll, 'Loot roll');
  if (resolution.lootType === 'data') {
    if (resolution.roll === 1) return { kind: 'credits', amount: 75 };
    if ([2, 4, 6].includes(resolution.roll)) {
      validateRoll(resolution.secondaryRoll ?? 0, 'Secondary roll');
      const multiplier = resolution.roll === 2 ? 10 : resolution.roll === 4 ? 15 : 20;
      return { kind: 'credits', amount: resolution.secondaryRoll! * multiplier };
    }
    if (resolution.roll === 3) return { kind: 'credits', amount: 150 };
    if (resolution.roll === 5) return { kind: 'credits', amount: 250 };
    if (resolution.roll >= 7 && resolution.roll <= 11) {
      return { kind: 'information', amount: [75, 100, 125, 150, 200][resolution.roll - 7] };
    }
    if (resolution.roll <= 14) return { kind: 'advancedWeapon' };
    if (resolution.roll <= 16) return { kind: 'advancedTechnology', technologyTable: 1 };
    if (resolution.roll <= 18) return { kind: 'advancedTechnology', technologyTable: 2 };
    return { kind: 'secret', amount: 200 };
  }

  if (resolution.roll <= 6) {
    return { kind: 'tradeGoods', amount: [75, 150, 200, 250, 300, 400][resolution.roll - 1] };
  }
  if (resolution.roll <= 11) return { kind: 'advancedWeapon' };
  if (resolution.roll <= 14) return { kind: 'advancedTechnology', technologyTable: 1 };
  if (resolution.roll <= 17) return { kind: 'advancedTechnology', technologyTable: 2 };
  return { kind: 'alienArtefact' };
}

export function isStargraveLootResolutionComplete(resolution: StargraveLootResolution): boolean {
  try {
    const reward = resolveStargraveLoot(resolution);
    if (reward.kind === 'information') return Boolean(resolution.informationChoice);
    if (reward.kind === 'secret') return Boolean(resolution.secretChoice);
    if (['advancedWeapon', 'advancedTechnology', 'alienArtefact'].includes(reward.kind)) return Boolean(resolution.itemId);
    return true;
  } catch {
    return false;
  }
}
